import { render, staticRenderFns } from "./columnstore_viewer_main.vue?vue&type=template&id=8b980b9a&"
import script from "./columnstore_viewer_main.vue?vue&type=script&lang=js&"
export * from "./columnstore_viewer_main.vue?vue&type=script&lang=js&"
import style0 from "./columnstore_viewer_main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports